export const appendSearchParamsIfSet = (url: string, searchParams: Record<string, string | null | undefined>): URL => {
  const newUrl = new URL(url)
  for (const [name, value] of Object.entries(searchParams)) {
    if (value) {
      newUrl.searchParams.append(name, value)
    }
  }
  return newUrl
}
